var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEnjoy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "14px",
    height: "14px",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icon /filter / enjoy") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M1.87167958,-4.68777063 L1.87167935,-4.68675466 C1.87167935,-3.4793803 2.85044965,-2.50060999 4.05782401,-2.50060999 C5.26519837,-2.50060999 6.24396868,-3.4793803 6.24396868,-4.68675466 L6.24346234,-4.68822532 L9.52318568,-4.68781729 L9.52318568,12.6653226 L6.23946234,12.6647747 L6.23847965,12.6462772 C6.15842607,11.5117681 5.21270384,10.616258 4.05782401,10.616258 C2.89655062,10.616258 1.94675708,11.5217109 1.87591852,12.6651414 L-1.40753766,12.6653226 L-1.40753766,-4.68781729 L1.87167958,-4.68777063 Z M6.51723676,0.778607011 L1.59841126,0.778607011 L1.59841126,7.33704101 L6.51723676,7.33704101 L6.51723676,0.778607011 Z",
    id: "path-5"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon-/filter-/-enjoy",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "color-/-gray",
    transform: "translate(5.893191, 5.991161)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-5"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Mask",
    fill: "currentColor",
    transform: "translate(4.057824, 4.057824) rotate(-315.000000) translate(-4.057824, -4.057824) ",
    xlinkHref: "#path-5"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnjoy);
export default __webpack_public_path__ + "static/media/enjoy.82b9075867669ab08b3444ac6fe80062.svg";
export { ForwardRef as ReactComponent };